module.exports = __webpack_public_path__ + "img/login.b7831d91.png";